module.exports = __webpack_public_path__ + "static/media/concert.4c43fbf1.jpg";